var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fdata.customerName + "-福豆发放",
            visible: _vm.dialogFormVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title: "温馨提示: 员工状态为禁用的员工不能进行积分发放。",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.formRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放方式：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                          on: { change: _vm.handleGrantTypeChange },
                          model: {
                            value: _vm.form.customerEmpType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerEmpType", $$v)
                            },
                            expression: "form.customerEmpType",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { label: 2 } },
                            [
                              _vm._v("指定员工\n              "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.form.customerEmpType !== 2,
                                  },
                                  on: { click: _vm.sel },
                                },
                                [_vm._v("选择员工")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { label: 3 },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "8px" } },
                                    [_vm._v("指定员工批量")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ButtonUploadExcel",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.form.customerEmpType === 3,
                                          expression:
                                            "form.customerEmpType === 3",
                                        },
                                      ],
                                      attrs: {
                                        onSuccess: _vm.onSuccess,
                                        getFileObject: _vm.handleFileObject,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  上传文件\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: { click: _vm.down },
                                    },
                                    [_vm._v("下载模板")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放数量：", prop: "issueQuantity" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          precision: 0,
                          step: 1,
                          "controls-position": "right",
                          placeholder: "请输入发放数量",
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.issueQuantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "issueQuantity", $$v)
                          },
                          expression: "form.issueQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放原因：", prop: "reason" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "reason", $$v)
                          },
                          expression: "form.reason",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.customerEmpType === 2 &&
                  _vm.form.customerEmpList &&
                  _vm.form.customerEmpList.length
                    ? _c("el-form-item", { attrs: { label: "已选员工：" } }, [
                        _c(
                          "div",
                          { staticClass: "selected-staff" },
                          _vm._l(_vm.form.customerEmpList, function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item.id,
                                staticClass: "selected-staff-tag",
                                attrs: {
                                  closable: "",
                                  type: "info",
                                  size: "medium",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.removeSelectedStaff(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.empName) +
                                    "-" +
                                    _vm._s(item.phone) +
                                    "\n          "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型：", prop: "orderType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.handleOrderTypeChange },
                          model: {
                            value: _vm.form.orderType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "orderType", $$v)
                            },
                            expression: "form.orderType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("福卡充值"),
                          ]),
                          _vm._v(" "),
                          _vm.form.orderType === 2
                            ? _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("权益卡包"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发卡类型：", prop: "sendType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发卡类型",
                            clearable: "",
                          },
                          on: { change: _vm.handleSendTypeChange },
                          model: {
                            value: _vm.form.sendType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sendType", $$v)
                            },
                            expression: "form.sendType",
                          },
                        },
                        _vm._l(_vm.sendTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "福卡面值：", prop: "integral" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        on: { input: _vm.handleIntegralChange },
                        model: {
                          value: _vm.form.integral,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "integral", $$v)
                          },
                          expression: "form.integral",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放总面值：" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          precision: 2,
                          step: 0.01,
                          min: 0,
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.totalFaceValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalFaceValue", $$v)
                          },
                          expression: "form.totalFaceValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.orderType === 1
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: "发放福卡：", prop: "fuCardId" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择",
                                  filterable: "",
                                  "filter-method": _vm.handleAgreementSearch,
                                },
                                on: { change: _vm.changeBrand },
                                model: {
                                  value: _vm.form.fuCardId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "fuCardId", $$v)
                                  },
                                  expression: "form.fuCardId",
                                },
                              },
                              _vm._l(_vm.brandOption, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.card_name,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.fuCardId && _vm.selectedCard
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "福卡详情：" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "card-detail-container" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card-detail-row" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "card-detail-label" },
                                          [_vm._v("卡片ID：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "card-detail-value" },
                                          [_vm._v(_vm._s(_vm.selectedCard.id))]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "card-detail-row" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "card-detail-label" },
                                          [_vm._v("卡片名称：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "card-detail-value" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.selectedCard.card_name)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedCard.description
                                      ? _c(
                                          "div",
                                          { staticClass: "card-detail-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "card-detail-label",
                                              },
                                              [_vm._v("卡片描述：")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "card-detail-value",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedCard.description
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.orderType === 2
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "选择权益卡包：",
                              prop: "packageId",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择福卡权益包",
                                      filterable: "",
                                      "filter-method": _vm.handlePackageSearch,
                                    },
                                    on: { change: _vm.selectPackage },
                                    model: {
                                      value: _vm.form.packageId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "packageId", $$v)
                                      },
                                      expression: "form.packageId",
                                    },
                                  },
                                  [
                                    _vm._l(_vm.packageOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    _vm._v(" "),
                                    _vm.hasMorePackages
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              cursor: "pointer",
                                              padding: "5px 0",
                                              color: "#409EFF",
                                            },
                                            on: { click: _vm.loadMorePackages },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  查看更多...\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "刷新列表",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-refresh",
                                        loading: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.searchPackages(true)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.form.packageId
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "卡片分配：" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "card-package-container" },
                                  [
                                    _vm.loading
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              padding: "15px",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-loading",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  margin: "5px 0 0 0",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [_vm._v("加载卡片数据中...")]
                                            ),
                                          ]
                                        )
                                      : [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "card-table-header",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "card-column" },
                                                [_vm._v("对应卡片")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "card-column" },
                                                [_vm._v("分配额度")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content: "刷新",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("el-button", {
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      icon: "el-icon-refresh",
                                                      loading: _vm.loading,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.refreshRelatedCards,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "card-table-body" },
                                            [
                                              _vm._l(
                                                _vm.relatedCards,
                                                function (card, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: card.id,
                                                      staticClass:
                                                        "card-table-row",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "card-column card-info",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "card-id-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "ID-" +
                                                                  _vm._s(
                                                                    card.id
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    card.cardName ||
                                                                      card.name ||
                                                                      "卡片名称"
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          card.internalName
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "card-internal-name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      card.internalName
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "card-column card-distribution",
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticStyle: {
                                                                width: "100px",
                                                              },
                                                              attrs: {
                                                                min: 0,
                                                                precision: 2,
                                                                step: 1,
                                                                size: "small",
                                                                "controls-position":
                                                                  "right",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.updateTotalDistribution,
                                                              },
                                                              model: {
                                                                value:
                                                                  card.distributionValue,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      card,
                                                                      "distributionValue",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "card.distributionValue",
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "unit-label",
                                                            },
                                                            [_vm._v("元")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm.relatedCards.length === 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "empty-cards",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-document",
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "没有关联的卡片"
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.relatedCards.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "distribution-summary",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "summary-item",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "summary-label",
                                                        },
                                                        [_vm._v("已分配总额：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "summary-value",
                                                          class: {
                                                            warning:
                                                              _vm.distributionWarningFlag,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatYuan(
                                                                _vm.totalDistribution
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "summary-item",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "summary-label",
                                                        },
                                                        [_vm._v("福卡面值：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "summary-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatYuan(
                                                                _vm.form
                                                                  .integral
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.distributionWarningFlag
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "distribution-warning",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-warning",
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.totalDistribution >
                                                  parseFloat(_vm.form.integral)
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    警告: 分配额度总和超过了福卡面值 (超出 " +
                                                            _vm._s(
                                                              _vm.formatYuan(
                                                                _vm.totalDistribution -
                                                                  parseFloat(
                                                                    _vm.form
                                                                      .integral
                                                                  )
                                                              )
                                                            ) +
                                                            ")\n                  "
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "\n                    警告: 分配额度总和小于福卡面值 (还差 " +
                                                            _vm._s(
                                                              _vm.formatYuan(
                                                                parseFloat(
                                                                  _vm.form
                                                                    .integral
                                                                ) -
                                                                  _vm.totalDistribution
                                                              )
                                                            ) +
                                                            ")\n                  "
                                                        ),
                                                      ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.orderType === 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "优惠券包：",
                            prop: "couponPackages",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                clearable: "",
                                "collapse-tags": "",
                                placeholder: "请选择优惠券包（可多选）",
                                filterable: "",
                                "filter-method": _vm.handleCouponPackageSearch,
                                loading: _vm.couponPackageLoading,
                              },
                              on: { change: _vm.handleCouponPackagesChange },
                              model: {
                                value: _vm.form.couponPackages,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "couponPackages", $$v)
                                },
                                expression: "form.couponPackages",
                              },
                            },
                            [
                              _vm._l(_vm.couponPackageOptions, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label:
                                      "" +
                                      item.packageName +
                                      (item.couponCount
                                        ? " (" + item.couponCount + "张)"
                                        : ""),
                                    value: item.id,
                                  },
                                })
                              }),
                              _vm._v(" "),
                              _vm.couponPackageOptions.length <
                              _vm.couponPackageTotal
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        cursor: "pointer",
                                        padding: "5px 0",
                                        color: "#409EFF",
                                      },
                                      on: { click: _vm.loadMoreCouponPackages },
                                    },
                                    [
                                      _vm._v(
                                        "\n              查看更多...\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放公司：", prop: "companyId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发放公司",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.form.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "companyId", $$v)
                            },
                            expression: "form.companyId",
                          },
                        },
                        _vm._l(_vm.companyOptions, function (company) {
                          return _c("el-option", {
                            key: company.id,
                            attrs: { label: company.name, value: company.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "项目编号：",
                        prop: "projectNumber",
                        required: _vm.form.sendType === 4,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入项目编号" },
                        model: {
                          value: _vm.form.projectNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "projectNumber", $$v)
                          },
                          expression: "form.projectNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "申请编号：", prop: "applicationNumber" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入申请编号" },
                        model: {
                          value: _vm.form.applicationNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applicationNumber", $$v)
                          },
                          expression: "form.applicationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "销售总价：", prop: "salesPrice" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, precision: 2, step: 0.01 },
                        model: {
                          value: _vm.form.salesPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesPrice", $$v)
                          },
                          expression: "form.salesPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "福卡有效期：", prop: "cardTimeRange" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "range-separator": "-",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                        },
                        on: { change: _vm.updateCardTimeRange },
                        model: {
                          value: _vm.form.cardTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cardTimeRange", $$v)
                          },
                          expression: "form.cardTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "内部备注：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "textarea" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "textarea" },
                        model: {
                          value: _vm.form.innerRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "innerRemark", $$v)
                          },
                          expression: "form.innerRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.submitting,
                    disabled: _vm.submitting,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("确认发放")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("SelectStaff", {
            ref: "selectStaffRef",
            attrs: { list: _vm.form.customerEmpList },
            on: { update: _vm.update },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ProjectRechargeRecordConfirm", {
        ref: "projectRechargeRecordConfirmRef",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }